import AuthService from "../login/auth.service";
import { consultasAPI } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class ExcedenteService {
  async fechas() {
    var data = JSON.stringify({
      canal: "WEB",
    });

    var config = {
      method: "post",
      url: consultasAPI + "excedentes/fechas",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  }

  async excedentes(ejercicio) {
    var data = JSON.stringify({
      canal: "WEB",
      ejercicio: ejercicio,
    });

    var config = {
      method: "post",
      url: consultasAPI + "excedentes",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  }
}
export default new ExcedenteService();